/**
 * ハイライトリールのページ
 *
 * 詳細ページに重ねると裏で地図やタイムラインが生きたままになるので、独立したルートにしている。
 */

import { Loader2 } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router'

import { PATHS } from '@/routes/paths'
import { useTripStore } from '@/store/useTripStore'

import { TripHighlightReel } from './components/trip-highlight-reel'

export const TripHighlightPage = () => {
  const navigate = useNavigate()
  const { trip_id: tripIdParam } = useParams<{ trip_id: string }>()
  const tripId = Number(tripIdParam)

  const detail = useTripStore((s) => s.detail)
  const timeline = useTripStore((s) => s.timeline)
  const route = useTripStore((s) => s.route)
  const fetchTripDetail = useTripStore((s) => s.fetchTripDetail)

  useEffect(() => {
    if (!Number.isFinite(tripId)) return
    if (detail?.id === tripId) return
    void fetchTripDetail(tripId)
  }, [tripId, detail?.id, fetchTripDetail])

  const days = useMemo(() => timeline?.days ?? [], [timeline])

  if (!detail || detail.id !== tripId) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black">
        <Loader2 className="size-6 animate-spin text-white/70" />
      </div>
    )
  }

  return (
    <TripHighlightReel
      trip={detail}
      days={days}
      routePoints={route?.points ?? []}
      open
      onOpenChange={(open) => {
        if (open) return
        navigate(PATHS.TRIPS.DETAIL.replace(':trip_id', String(tripId)))
      }}
    />
  )
}
